var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNotificationIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 24,
    viewBox: "0 0 22 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.672817 17.8325C1.12078 18.2804 1.68835 18.5194 2.31572 18.5194H18.7741C19.4015 18.5194 19.9688 18.2805 20.417 17.8325C21.343 16.9066 21.3132 15.383 20.3274 14.4871L19.5807 13.8299C19.1027 13.382 18.8339 12.7844 18.8339 12.1272V8.4831C18.8339 4.59994 15.8469 0 10.769 0H10.3211C5.2432 0 2.25614 4.57012 2.25614 8.4831V12.1272C2.25614 12.7844 1.98736 13.4116 1.50939 13.8299L0.762635 14.4871C-0.22329 15.383 -0.253321 16.9063 0.672832 17.8325H0.672817Z",
    fill: "#3C2166"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5308 23.9997C12.2633 23.9997 13.6672 22.5958 13.6672 20.8633H7.39453C7.39474 22.5957 8.79864 23.9997 10.5309 23.9997H10.5308Z",
    fill: "#3C2166"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotificationIcon);
export default __webpack_public_path__ + "static/media/notification-icon.d75d9199256be95ccdab2250e82c56c8.svg";
export { ForwardRef as ReactComponent };